/**
 * Registry of master tables.
 *
 * Each entry is a single string that serves two purposes:
 *  - API path segment → GET /catalogs/{value}
 *  - Redux key        → state.catalogs.masterTables[value]
 *
 * Since the same value is used as the Redux key, entries are kebab-case
 * (e.g. 'product-types') and are accessed with bracket notation:
 * state.catalogs.masterTables['product-types'].
 *
 * Adding a new MT = one line here. Everything else auto-generates.
 */
export const MASTER_TABLE_KEYS = [
  'currencies',
  'interveneer-types',
  'product-types',
  'countries',
  'document-types',
  'provinces',
  'street-types',
  'professions',
  'phone-prefixes',
  'activity-types',
  'marital-statuses',
  'marital-regimes',
  'activity-sectors',
] as const

export type MasterTableKey = (typeof MASTER_TABLE_KEYS)[number]

export type MasterTableItem = {
  inversis_code: string
  inversis_value: string
  enabled: boolean
  code: string
  value: string
  description: string
  parent_catalog?: MasterTableKey
  parent_code?: string
  order?: string
}
